import {
  autoRoster,
  benefit2,
  benefit3,
  benefit4,
  benefit5,
  calendarEvents,
  calendarYear,
  customLeave,
  eventManagement,
  hrManagement,
  leaveManagement,
  leaveTracking,
  manageEmployees,
  onOffboarding,
  rostering,
  shiftSwap,
  roster,
  fingerPrint,
  terminal,
} from "../assets/icons";

import one from "../assets/one.png";
import two from "../assets/two.png";
import three from "../assets/three.png";
import four from "../assets/four.png";
import five from "../assets/five.png";

export const features = [
  {
    name: "Rostering",
    icon: rostering,
    description: "Manage workforce scheduling with automated rostering.",
  },
  {
    name: "HR Management",
    icon: hrManagement,
    description: "Simplify your HR and employee management tasks.",
  },
  {
    name: "Leave Management",
    icon: leaveManagement,
    description:
      "Embrace smarter and better way of managing time-off requests.",
  },
  {
    name: "Calendar & Events",
    icon: calendarEvents,
    description: "Enhance collaboration with calendar & events feature.",
  },
  {
    name: "Attendance Management",
    icon: terminal,
    description: "Track real-time attendance with biometric support.",
  },
];

export const details = [
  {
    name: "One-Stop Solution For Roster Management",
    description:
      "Revolutionize your workforce management with our cutting-edge automated rostering feature leveraging mathematical modeling and operations research, a powerful tool designed to simplify and optimize the scheduling of your employees.",
    leftName: "Automated Rostering",
    leftDescription:
      "Smarter, simplified, optimized and automated rostering of employees.",
    leftIcon: autoRoster,
    rightName: "Shift Swapping",
    rightDescription:
      "Let your employees exchange shifts seamlessly, within defined parameters.",
    rightIcon: shiftSwap,
    image: one,
  },
  {
    name: "Elevate Performance, Simplify Management",
    description:
      "Simplify your HR and optimize human resource processes - from efficient employee onboarding / offboarding and centralized personnel data management to handling leaves, building company culture and elevating performance.",
    leftName: "Onboarding & Offboarding",
    leftDescription:
      "Efficient, smarter and better onboarding / offboarding processes.",
    leftIcon: onOffboarding,
    rightName: "Managing Employees",
    rightDescription:
      "Amplify team productivity with effortless management to get limitless results.",
    rightIcon: manageEmployees,
    image: two,
  },
  {
    name: "A Hassle-Free Software For Leave Management",
    description:
      "The ultimate solution for effortless tracking, managing, and optimizing employee leaves within your organization. Say goodbye to the complexities of manual leave tracking and embrace a streamlined, automated approach to managing time-off requests.",
    leftName: "Customizable Leaves",
    leftDescription:
      "Create and customize leaves that better suit your leave policy.",
    leftIcon: customLeave,
    rightName: "Leave Tracking",
    rightDescription:
      "Record and track all user leave data, ensuring easy access and efficient management.",
    rightIcon: leaveTracking,
    image: three,
  },
  {
    name: "A Software Designed To Meet Your Needs",
    description:
      "Unlock a new level of organizational efficiency with our calendar and events feature, a dynamic tool designed to enhance collaboration and keep your team aware of events.",
    leftName: "Calendar Year",
    leftDescription:
      "Integrate leave calendar and organize company events in one accessible platform.",
    leftIcon: calendarYear,
    rightName: "Event Management",
    rightDescription:
      "Generate or update customizable events from yearly calendar for your desired team.",
    rightIcon: eventManagement,
    image: four,
  },
  {
    name: "Simplify Attendance With Biometric Precision",
    description:
      "Biometric attendance management uses fingerprint and facial recognition to track employee attendance providing real-time data synchronization along with being fully integrated with roster and leave management.",
    leftName: "Biometric Attendance",
    leftDescription:
      "Supports biometric attendance via mobile phone along with real time data integration.",
    leftIcon: fingerPrint,
    rightName: "Roster & Leave Integration",
    rightDescription:
      "Attendance system is fully incorporated with rostering and leave modules.",
    rightIcon: roster,
    image: five,
  },
];

export const generalBenefits = [
  "Best value for money",
  "Streamlined onboarding/offboarding",
  "Increased employee performance",
  "Efficient employee management",
  "Fast and expendable",
  "Painless shift scheduling",
  "Reduction in administrative tasks",
  "Increased transparency",
  "An experience that employees love",
  "Biometric system integration",
  "Real-time attendance updates",
  // "Data-driven decision-making",
  "Automated leave management",
  "Intuitive, collaborative interface",
];

export const featureBenefits = [
  {
    name: "Automated Rostering",
    number: "one",
    z: "z-[110]",
    description:
      "Enjoy seamless operations and a well-balanced workforce, all at your fingertips.",
    icon: benefit2,
    bgColor: "bg-green-100",
    iconColor: "text-green-600",
    more: [
      "Optimized resource allocation",
      "Employee preference integration",
      "Compliance with work regulations",
      "Efficient constraint handling",
      "Visual representation for analysis",
      "Transparent and intuitive",
    ],
  },
  {
    name: "HR Management",
    number: "two",
    z: "z-[62]",
    description:
      "Empower your HR team to focus on strategic initiatives, driving organizational success.",
    icon: benefit3,
    bgColor: "bg-red-100",
    iconColor: "text-red-500",
    more: [
      "Centralized employee information",
      "Employee onboarding / offboarding",
      "Department-wise employee data",
      "Document requests as events",
      "Reporting manager assignement",
      "Permissions management",
    ],
  },
  {
    name: "Leave Management",
    number: "three",
    z: "z-[52]",
    description:
      "Simplify absence tracking, empower employees with self-service options and ensure compliance.",
    icon: benefit4,
    bgColor: "bg-gray-100",
    iconColor: "text-gray-600",
    more: [
      "Customizable leave policies",
      "Effortless leave requests",
      "Real-time leave balances",
      "Automated approval workflows",
      "Comprehensive leave tracking",
      "Employee self-service",
    ],
  },
  {
    name: "Calendar & Events",
    number: "four",
    z: "z-[33]",
    description:
      "Streamline event planning, deadlines, and appointments in one centralized hub.",
    icon: benefit5,
    bgColor: "bg-blue-100",
    iconColor: "text-blue-500",
    more: [
      "Yearly leave calendar",
      "Real-time event updates",
      "Collaborative event planning",
      "Visual representation of schedules",
      "Enhanced team collaboration",
      "Event reminders on dashboard",
    ],
  },
  {
    name: "Attendance Management",
    number: "five",
    z: "z-[22]",
    description:
      "Provides biometric accuracy with real-time leave updates for flawless attendance.",
    icon: terminal,
    bgColor: "bg-purple-100",
    iconColor: "text-purple-600",
    more: [
      "Integration with attendance terminals",
      "Supports biometric attendance methods",
      "Displays user attendance data",
      "Exportable as excel files",
      "Incorporated with roster and leave modules",
      "Statistics displayed in user friendly graphics",
    ],
  },
];

export const plans = [
  // {
  //   name: "Starter",
  //   price: "Coming soon...",
  //   note: "Slate helps you see how many more days you need...",
  //   features: [
  //     { name: "Unlimited product updates", status: true },
  //     { name: "Unlimited product", status: true },
  //     { name: "Unlimited product", status: true },
  //     { name: "1GB Cloud storage", status: false },
  //     { name: "Email and community support", status: false },
  //     { name: "24/7 technical support", status: false },
  //   ],
  // },
  // {
  //   name: "Standard",
  //   price: "Coming soon...",
  //   note: "Slate helps you see how many more days you need...",
  //   features: [
  //     { name: "Unlimited product updates", status: true },
  //     { name: "Unlimited product", status: true },
  //     { name: "Unlimited product", status: true },
  //     { name: "1GB Cloud storage", status: false },
  //     { name: "Email and community support", status: false },
  //     { name: "24/7 technical support", status: false },
  //   ],
  // },
  {
    name: "Enterprise",
    price: "Contact Us",
    note: "Slate helps you see how many more days you need...",
    features: [
      { name: "Onboarding / Offboarding", status: true },
      { name: "Document Management", status: true },
      { name: "Leave Management", status: true },
      { name: "Rostering", status: true },
      { name: "Shift Swap", status: true },
      { name: "Payroll Export", status: true },
      { name: "Reports And Analytics", status: true },
      { name: "Calendar And Events", status: true },
      { name: "Android / iOS Mobile App", status: true },
      { name: "Smartphone Biometric Attendance", status: true },
    ],
  },
];

export const mobileFeatures = [
  "Cross-platform mobile app",
  "On-the-go accessibility",
  "Real-time updates",
  "As intuitive and easy as the desktop version",
  "Convenient flexibility",
  "User-friendly interface",
];

export const countries = [
  "Afghanistan,+93",
  "Albania,+355",
  "Algeria,+213",
  "American Samoa,+1-684",
  "Andorra,+376",
  "Angola,+244",
  "Anguilla,+1-264",
  "Antarctica,+672",
  "Antigua and Barbuda,+1-268",
  "Argentina,+54",
  "Armenia,+374",
  "Aruba,+297",
  "Australia,+61",
  "Austria,+43",
  "Azerbaijan,+994",
  "Bahamas,+1-242",
  "Bahrain,+973",
  "Bangladesh,+880",
  "Barbados,+1-246",
  "Belarus,+375",
  "Belgium,+32",
  "Belize,+501",
  "Benin,+229",
  "Bermuda,+1-441",
  "Bhutan,+975",
  "Bolivia,+591",
  "Bosnia and Herzegovina,+387",
  "Botswana,+267",
  "Brazil,+55",
  "British Indian Ocean Territory,+246",
  "British Virgin Islands,+1-284",
  "Brunei,+673",
  "Bulgaria,+359",
  "Burkina Faso,+226",
  "Burundi,+257",
  "Cambodia,+855",
  "Cameroon,+237",
  "Canada,+1",
  "Cape Verde,+238",
  "Cayman Islands,+1-345",
  "Central African Republic,+236",
  "Chad,+235",
  "Chile,+56",
  "China,+86",
  "Christmas Island,+61",
  "Cocos Islands,+61",
  "Colombia,+57",
  "Comoros,+269",
  "Cook Islands,+682",
  "Costa Rica,+506",
  "Croatia,+385",
  "Cuba,+53",
  "Curacao,+599",
  "Cyprus,+357",
  "Czech Republic,+420",
  "Democratic Republic of the Congo,+243",
  "Denmark,+45",
  "Djibouti,+253",
  "Dominica,+1-767",
  "Dominican Republic,+1-809,1-829,1-849",
  "East Timor,+670",
  "Ecuador,+593",
  "Egypt,+20",
  "El Salvador,+503",
  "Equatorial Guinea,+240",
  "Eritrea,+291",
  "Estonia,+372",
  "Ethiopia,+251",
  "Falkland Islands,+500",
  "Faroe Islands,+298",
  "Fiji,+679",
  "Finland,+358",
  "France,+33",
  "French Polynesia,+689",
  "Gabon,+241",
  "Gambia,+220",
  "Georgia,+995",
  "Germany,+49",
  "Ghana,+233",
  "Gibraltar,+350",
  "Greece,+30",
  "Greenland,+299",
  "Grenada,+1-473",
  "Guam,+1-671",
  "Guatemala,+502",
  "Guernsey,+44-1481",
  "Guinea,+224",
  "Guinea-Bissau,+245",
  "Guyana,+592",
  "Haiti,+509",
  "Honduras,+504",
  "Hong Kong,+852",
  "Hungary,+36",
  "Iceland,+354",
  "India,+91",
  "Indonesia,+62",
  "Iran,+98",
  "Iraq,+964",
  "Ireland,+353",
  "Isle of Man,+44-1624",
  "Israel,+972",
  "Italy,+39",
  "Ivory Coast,+225",
  "Jamaica,+1-876",
  "Japan,+81",
  "Jersey,+44-1534",
  "Jordan,+962",
  "Kazakhstan,+7",
  "Kenya,+254",
  "Kiribati,+686",
  "Kosovo,+383",
  "Kuwait,+965",
  "Kyrgyzstan,+996",
  "Laos,+856",
  "Latvia,+371",
  "Lebanon,+961",
  "Lesotho,+266",
  "Liberia,+231",
  "Libya,+218",
  "Liechtenstein,+423",
  "Lithuania,+370",
  "Luxembourg,+352",
  "Macau,+853",
  "Macedonia,+389",
  "Madagascar,+261",
  "Malawi,+265",
  "Malaysia,+60",
  "Maldives,+960",
  "Mali,+223",
  "Malta,+356",
  "Marshall Islands,+692",
  "Mauritania,+222",
  "Mauritius,+230",
  "Mayotte,+262",
  "Mexico,+52",
  "Micronesia,+691",
  "Moldova,+373",
  "Monaco,+377",
  "Mongolia,+976",
  "Montenegro,+382",
  "Montserrat,+1-664",
  "Morocco,+212",
  "Mozambique,+258",
  "Myanmar,+95",
  "Namibia,+264",
  "Nauru,+674",
  "Nepal,+977",
  "Netherlands,+31",
  "Netherlands Antilles,+599",
  "New Caledonia,+687",
  "New Zealand,+64",
  "Nicaragua,+505",
  "Niger,+227",
  "Nigeria,+234",
  "Niue,+683",
  "North Korea,+850",
  "Northern Mariana Islands,+1-670",
  "Norway,+47",
  "Oman,+968",
  "Pakistan,+92",
  "Palau,+680",
  "Palestine,+970",
  "Panama,+507",
  "Papua New Guinea,+675",
  "Paraguay,+595",
  "Peru,+51",
  "Philippines,+63",
  "Pitcairn,+64",
  "Poland,+48",
  "Portugal,+351",
  "Puerto Rico,+1-787,1-939",
  "Qatar,+974",
  "Republic of the Congo,+242",
  "Reunion,+262",
  "Romania,+40",
  "Russia,+7",
  "Rwanda,+250",
  "Saint Barthelemy,+590",
  "Saint Helena,+290",
  "Saint Kitts and Nevis,+1-869",
  "Saint Lucia,+1-758",
  "Saint Martin,+590",
  "Saint Pierre and Miquelon,+508",
  "Saint Vincent and the Grenadines,+1-784",
  "Samoa,+685",
  "San Marino,+378",
  "Sao Tome and Principe,+239",
  "Saudi Arabia,+966",
  "Senegal,+221",
  "Serbia,+381",
  "Seychelles,+248",
  "Sierra Leone,+232",
  "Singapore,+65",
  "Sint Maarten,+1-721",
  "Slovakia,+421",
  "Slovenia,+386",
  "Solomon Islands,+677",
  "Somalia,+252",
  "South Africa,+27",
  "South Korea,+82",
  "South Sudan,+211",
  "Spain,+34",
  "Sri Lanka,+94",
  "Sudan,+249",
  "Suriname,+597",
  "Svalbard and Jan Mayen,+47",
  "Swaziland,+268",
  "Sweden,+46",
  "Switzerland,+41",
  "Syria,+963",
  "Taiwan,+886",
  "Tajikistan,+992",
  "Tanzania,+255",
  "Thailand,+66",
  "Togo,+228",
  "Tokelau,+690",
  "Tonga,+676",
  "Trinidad and Tobago,+1-868",
  "Tunisia,+216",
  "Turkey,+90",
  "Turkmenistan,+993",
  "Turks and Caicos Islands,+1-649",
  "Tuvalu,+688",
  "U.S. Virgin Islands,+1-340",
  "Uganda,+256",
  "Ukraine,+380",
  "United Arab Emirates,+971",
  "United Kingdom,+44",
  "United States,+1",
  "Uruguay,+598",
  "Uzbekistan,+998",
  "Vanuatu,+678",
  "Vatican,+379",
  "Venezuela,+58",
  "Vietnam,+84",
  "Wallis and Futuna,+681",
  "Western Sahara,+212",
  "Yemen,+967",
  "Zambia,+260",
  "Zimbabwe,+263",
];

export const AllPermissions = [
  "HR Manager",
  "Roster Manager",
  "Settings Manager",
  // "Permission Manager",
];
